//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ResizeSensor } from 'css-element-queries';
import Papa from 'papaparse';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import { guessIfDate, naturalSort, reverseNaturalSort, saveFile } from '@/helpers/util';
import TabularRow from './TabularRow.vue';
import TabularFormater from './formater';

const nameMigrationMap = {
  '"{$id}"': '$id',
  $result: 'result',
};

export default {
  name: 'DpTabular',
  components: {
    TabularRow,
    DynamicScroller,
    DynamicScrollerItem,
  },
  props: {
    displayOptions: { type: Object, default: () => {} },
    value: { type: Array, default: () => [] },
    useKpiNaming: { type: Boolean, default: false },
    configurable: { type: Boolean, default: false },
  },
  data() {
    return {
      columns: [],
      resizing: false,
      sorting: {},
      draggedColumn: {},
      showSettings: false,
      tableHasScroll: false,
      rowMaxWidth: 0,
      formatters: {},
      formatings: {
        Number: 'number',
        String: 'string',
        Date: 'ms',
        Raw: 'raw',
      },
      columnSettingsOpen: '',
    };
  },
  computed: {
    orderedColumns() {
      return ((this.displayOptions && this.displayOptions.columns) || this.columns)
        .slice()
        .filter((column) => !(this.displayOptions && this.displayOptions.hiddenColumns)
            || this.displayOptions.hiddenColumns.indexOf(column.name) === -1)
        .sort((a, b) => a.order - b.order)
        .map(this.mangleColumnName);
    },
    formatedValue() {
      // const { formaters } = this.displayOptions || {};
      const formaters = this.formatters;

      return (formaters && Object.keys(formaters).length !== 0)
        ? this.value.map((row) => Object.keys(row)
          .reduce((obj, key) => ({
            ...obj,
            [key]: (key !== '$hiddenRSIndex' && formaters[key] !== null)
              ? TabularFormater(formaters[key], row[key])
              : row[key],
          }), {}))
        : this.value;
    },
    displayData() {
      // Migrate to new data style
      const mappedData = this.formatedValue.map((d) => {
        const newDataObj = {};
        Object.keys(d).forEach((k) => {
          const migratedName = nameMigrationMap[k];
          if (migratedName) {
            newDataObj[migratedName] = d[k];
          }
          newDataObj[k] = d[k];
        });
        return newDataObj;
      });

      const data = mappedData;

      if (data.length === 0) {
        return [];
      }

      const sortings = [
        () => data,
        naturalSort,
        reverseNaturalSort,
      ];

      const key = data[0].key ? 'key' : this.sorting.by;

      return sortings[this.sorting.sort || 0](data, [key, 'raw']);
    },
    scrollbarWidth() {
      const { tbody } = this.$refs;

      return tbody.offsetWidth - tbody.clientWidth;
    },
  },
  watch: {
    displayData() {
      this.columns = this.getColumns();
      // this.formatters = this.getFormatters();
    },
    displayOptions() {
      this.formatters = this.getFormatters();
    },
    value: {
      immediate: true,
      handler() {
        this.formatters = this.getFormatters();
      },
    },
  },
  mounted() {
    this.columns = this.getColumns();
    this.sorting = this.getSorting();
    this.formatters = this.getFormatters();

    this.$nextTick(() => {
      this.handleContainerResize();
    });

    this.resizeSensor = new ResizeSensor(this.$el, this.handleContainerResize);
  },
  beforeDestroy() {
    this.resizeSensor.detach(this.$el);
  },
  methods: {
    removeHiddenColumn(e) {
      const { hiddenColumns } = this.displayOptions || {};
      const draggedColumn = e.dataTransfer.getData('text');

      if (hiddenColumns) {
        this.$emit('update-options', {
          hiddenColumns: hiddenColumns.filter((column) => column !== draggedColumn),
        });
      }
    },
    addHiddenColumn(name) {
      this.$emit('update-options', {
        hiddenColumns: [
          ...((this.displayOptions && this.displayOptions.hiddenColumns) || []),
          name,
        ],
      });
    },
    getFormatters() {
      const formatters = {};

      if (!this.value || this.value.length === 0) {
        return formatters;
      }

      const lastResult = this.value[this.value.length - 1];

      this.columns.forEach((col) => {
        const { name } = col;
        if (formatters[name]) return;
        let defaultType = null;
        const value = lastResult[name]?.display;
        if (guessIfDate(value)) {
          defaultType = 'ms';
        } else if (typeof value === 'number') {
          defaultType = 'number';
        } else {
          defaultType = 'string';
        }
        formatters[name] = defaultType;
      });

      return formatters;
    },
    headerHasFormating(header, val) {
      return this.formatters[header] === val;
    },
    openColumnSettings(event, header) {
      this.columnSettingsOpen = this.columnSettingsOpen === header
        ? ''
        : header;
    },
    getClearColumnName(name) {
      const exceptions = ['$total', '$result', '$binStart', '$binMiddle', '$binEnd'];
      const match = name.match(/^"\{(.*?)\}"$/);

      return name === '$ts'
        ? 'Timestamp'
        : (match && match[1])
          || (exceptions.includes(name) && name.replace(/^\$/, ''))
          || name;
    },
    mangleColumnName({ name, ...rest }) {
      // Migrate old KPIs state to use new column names
      const migratedName = nameMigrationMap[name] || name;
      if (this.useKpiNaming) {
        return {
          ...rest,
          name: migratedName,
          displayName: this.getClearColumnName(name),
        };
      }

      return {
        name: migratedName,
        ...rest,
      };
    },
    getColumns() {
      return this.value
        .reduce((keys, cur) => {
          const curKeys = Object.keys(cur);
          const keysToAdd = curKeys.filter((k) => !keys.includes(k));

          return keys.concat(keysToAdd).filter((k) => k !== '$hiddenRSIndex');
        }, [])
        .map(this.toColumnObj);
    },
    getSorting() {
      return (this.displayOptions && this.displayOptions.sort) || {
        sort: '', // 0: none, 1: ascending, 2: descending
        by: '',
      };
    },
    toColumnObj(name, i = 0) {
      const column = this.getColumnObj(name);

      return column || {
        name,
        width: '',
        order: i,
      };
    },
    getColumnObj(name) {
      return this.columns.find((c) => c.name === name);
    },
    startResize(e, header) {
      const { left } = this.$el.getBoundingClientRect();

      this.resizing = {
        header,
        startWidth: this.$refs[header.name][0].clientWidth,
        startLeft: e.pageX - left,
        left: e.pageX - left,
      };
    },
    handleResize(e) {
      if (this.resizing) {
        this.resizing = {
          ...this.resizing,
          left: e.pageX - this.$el.getBoundingClientRect().left,
        };
      }
    },
    endResize() {
      if (this.resizing) {
        const {
          header,
          startWidth,
          startLeft,
          left,
        } = this.resizing;

        const width = startWidth + (left - startLeft);

        this.columns = this.columns
          .filter((c) => c.name === header.name)
          .map((c) => ({ ...c, width: `${width}px` }))
          .concat(this.columns.filter((c) => c.name !== header.name));

        this.resizing = false;
        this.$emit('change-columns', this.columns);
      }
    },
    handleSorting(header) {
      const newSorting = header.name === this.sorting.by
        ? (this.sorting.sort + 1) % 3
        : 1;

      this.sorting = {
        sort: newSorting,
        by: newSorting === 0 ? '' : header.name,
      };

      this.$emit('change-sort', this.sorting);
    },
    setFormating(header, formating) {
      const { formatters } = this;

      this.$emit('update-options', {
        formaters: {
          ...formatters,
          [header]: formatters[header] === formating
            ? null
            : formating,
        },
      });
    },
    handleDragStart(e, header) {
      this.draggedColumn = this.getColumnObj(header.name);
      e.dataTransfer.setData('text/plain', header.name);
      document.querySelector('.dp-app').classList.add('is-dragging-data');
    },
    handleDragEnd() {
      document.querySelector('.dp-app').classList.remove('is-dragging-data');
    },
    handleDragOver() {},
    handleDragDrop(e, header) {
      const tempColumns = this.columns.slice();
      const droppedAt = this.getColumnObj(header.name).order;

      this.columns = tempColumns
        .map((c) => {
          if (c.order === droppedAt) {
            return {
              ...c,
              order: this.draggedColumn.order,
            };
          }

          if (c.order === this.draggedColumn.order) {
            return {
              ...c,
              order: droppedAt,
            };
          }

          return c;
        });
      this.$emit('change-columns', this.columns);
    },
    getColumnWidth(column) {
      return column.width ? { flex: `0 0 ${column.width}` } : {};
    },
    toggleSettings() {
      this.showSettings = !this.showSettings;
    },
    exportAsCSV() {
      const columns = this.orderedColumns;

      const csv = Papa.unparse({
        fields: columns.map((o) => o.displayName),
        data: this.displayData
          .map(({ $hiddenRSIndex, ...d }) => d)
          .reduce((arr, cur) => arr.concat([columns.map((c) => cur[c.name].display || '')]), []),
      });
      const blob = new Blob([
        new Uint8Array([0xEF, 0xBB, 0xBF]), // set UTF-8 BOM
        csv,
      ], { type: 'text/csv;charset=utf-8' });

      saveFile(blob, 'tableData.csv');
    },
    handleContainerResize() {
      const { tbody } = this.$refs;

      this.tableHasScroll = tbody.scrollHeight > tbody.clientHeight;
      this.rowMaxWidth = tbody.clientWidth - 40 + (this.tableHasScroll ? this.scrollbarWidth : 1);
    },
  },
};
